import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Box, Button, FormControlLabel, Grid, Radio, Typography, useTheme} from "@mui/material";
import {useFormContext} from "react-hook-form";
import {useRecoilState, useRecoilValue} from "recoil";
import {bookingDataValueState, counterSaleManagementValueState, listVehiclesReadyState, rentalAgreementFillingValueState} from "../../state";
import {IRaFillingForm} from "../../../models/models";
import _ from "underscore";
import {FormAutocomplete, FormRadioGroup, FormTextField} from "../../../common/form-fields-wrappers";
import {deepClone} from "../../../../../util/state/commonFunctions";

const VehicleDetails = () => {
	const {t} = useTranslation(['network', 'translation']);
	const theme = useTheme();
	// Use Context
	const raFillingDataForm = useFormContext<IRaFillingForm>();
	const raFilling = useRecoilValue(rentalAgreementFillingValueState);
	const [counterSaleManagement, setCounterSaleManagement] = useRecoilState(counterSaleManagementValueState);
	// stato iniziale
	const [selectionCarOptionList, setSelectionCarOptionList] = useState({acriss: [], sipp: [], plate: []});
	const [brandModelDescr, setBrandModelDescr] = useState("");
	const listVehiclesReady = useRecoilValue(listVehiclesReadyState);
	const bookingDataValue: any = useRecoilValue(bookingDataValueState);

	const handleChangeAcriss = (event: null | React.SyntheticEvent, value: any) => {
		if (!!event) {
			event.stopPropagation();
		}

		if (!listVehiclesReady) {
			return;
		}

		raFillingDataForm.setValue('vehicleDetails.sipp', null);
		raFillingDataForm.setValue('vehicleDetails.plate', null);
		setVehicleFormFields(null);
		const sco = Object.assign({}, selectionCarOptionList);

		if (sco.acriss.length === 0) {
			// @ts-ignore
			sco['acriss'] = [...new Map(listVehiclesReady.map((item: any) => [item['acrissCode'], item])).values()]
					.map(elem => { return {code: elem.acrissCode, description: elem.acrissLabel}});
		}

		if (!value) {
			// @ts-ignore
			sco['sipp'] = [...new Map(listVehiclesReady.map(item => [item['sippCode'], item])).values()]
							.map(elem => {
								return {
									code: elem.sippCode,
									description: elem.sippLabel,
									acrissCode: elem.acrissCode,
									acrissLabel: elem.acrissLabel
								};
							});
			// @ts-ignore
			sco['plate'] = listVehiclesReady;
		}
		else {
			// @ts-ignore
			sco['sipp'] = [...new Map(listVehiclesReady.map(item => [item['acrissCode'] + item['sippCode'], item])).values()]
							.filter(elem => elem.acrissCode === value.code)
							.map(elem => {
								return {
									code: elem.sippCode,
									description: elem.sippLabel,
									acrissCode: elem.acrissCode,
									acrissLabel: elem.acrissLabel
								};
							});

			// @ts-ignore
			sco['plate'] = listVehiclesReady.filter(elem => elem.acrissCode === value.code);
		}
		setSelectionCarOptionList(sco);
	}

	const handleChangeSipp = (event: React.SyntheticEvent, value: any) => {
		if (!!event) {
			event.stopPropagation();
		}

		if (!listVehiclesReady) {
			return;
		}

		raFillingDataForm.setValue('vehicleDetails.plate', null);
		setVehicleFormFields(null);

		const acrissCode = raFillingDataForm.getValues('vehicleDetails.acriss');

		const sco = Object.assign({}, selectionCarOptionList);

		if (sco.acriss.length === 0) {
			// @ts-ignore
			sco['acriss'] = [...new Map(listVehiclesReady.map((item: any) => [item['acrissCode'], item])).values()]
				.map(elem => { return {code: elem.acrissCode, description: elem.acrissLabel}});
		}

		if (!value) {
			// @ts-ignore
			sco['plate'] = listVehiclesReady.filter((elem: any) => !acrissCode || elem.acrissCode === acrissCode.code);
		}
		else {
			if (!!value.code && !acrissCode) { // !null && null
				raFillingDataForm.setValue('vehicleDetails.acriss', {code: value.acrissCode, description: value.acrissLabel});
			}

			if (!!acrissCode) {
				sco['plate'] = listVehiclesReady.filter((elem: any) => acrissCode.code === elem.acrissCode && elem.sippCode === value.code);
			} else {
				sco['plate'] = listVehiclesReady.filter((elem: any) => elem.sippCode === value.code);
			}
		}
		setSelectionCarOptionList(sco);
	}

	const handleChangePlate = (event: React.SyntheticEvent | null, value: any) => {
		if(event !== null ) {
			event.stopPropagation();
		}

		if (!listVehiclesReady) {
			return;
		}

		let acrissCode: any, sippCode: any;

		if (!!value)  {
			raFillingDataForm.setValue('vehicleDetails.acriss', {code: value.acrissCode, description: value.acrissLabel});
			raFillingDataForm.setValue('vehicleDetails.sipp', {code: value.sippCode, description: value.sippLabel, acrissCode: value.acrissCode, acrissLabel: value.acrissLabel});
			acrissCode = {code: value.acrissCode, description: value.acrissLabel};
			sippCode = {code: value.sippCode, description: value.sippLabel, acrissCode: value.acrissCode, acrissLabel: value.acrissLabel};
		}
		else {
			acrissCode = raFillingDataForm.getValues('vehicleDetails.acriss');
			sippCode = raFillingDataForm.getValues('vehicleDetails.sipp');
		}

		const sco = Object.assign({}, selectionCarOptionList);

		if (sco.acriss.length === 0) {
			// @ts-ignore
			sco['acriss'] = [...new Map(listVehiclesReady.map((item: any) => [item['acrissCode'], item])).values()]
				.map(elem => { return {code: elem.acrissCode, description: elem.acrissLabel}});
		}

		sco['plate'] = listVehiclesReady;
		if (!!acrissCode) {
			sco['plate'] = sco['plate'].filter((elem: any) => elem.acrissCode === acrissCode.code)
		}

		if (!!sippCode) {
			sco['plate'] = sco['plate'].filter((elem: any) => elem.sippCode === sippCode.code)
		}

		if (!!acrissCode) {
			// @ts-ignore
			sco['sipp'] = [...new Map(listVehiclesReady.map(item => [item['acrissCode'] + item['sippCode'], item])).values()]
								.filter((elem: any) => elem.acrissCode === acrissCode.code)
								.map(elem => {
									return {
										code: elem.sippCode,
										description: elem.sippLabel,
										acrissCode: elem.acrissCode,
										acrissLabel: elem.acrissLabel
									};
								});
		} else {
			// @ts-ignore
			sco['sipp'] = [...new Map(listVehiclesReady.map(item => [item['sippCode'], item])).values()]
										.map(elem => {
											return {
												code: elem.sippCode,
												description: elem.sippLabel,
												acrissCode: elem.acrissCode,
												acrissLabel: elem.acrissLabel
											};
										});
		}

		setSelectionCarOptionList(sco);

		// set form value
		setVehicleFormFields(value);

		setBrandModelDescr((!!value?.brandDescription ? value.brandDescription + ' ' : '') + (!!value?.modelDescription ? value.modelDescription: ''));

		if (!!counterSaleManagement?.last) {
			const csmClone = deepClone(counterSaleManagement.last);
			csmClone.selectedAcriss = {code: value?.acrissCode, description: value?.acrissLabel};
			setCounterSaleManagement({previous: counterSaleManagement.last, last: csmClone});
		}
	}

	const handleReset = (e: React.SyntheticEvent) => {
		e.stopPropagation();

		raFillingDataForm.setValue('vehicleDetails.acriss', null);
		raFillingDataForm.setValue('vehicleDetails.sipp', null);
		raFillingDataForm.setValue('vehicleDetails.plate', null);

		handleChangeAcriss(e, null);
		setBrandModelDescr("");
	}

	/**
	 * Set vehicle form fields
	 * @param value
	 */
	const setVehicleFormFields = (value: any) => {
		// set form value
		raFillingDataForm.setValue('vehicleDetails.vehicleID', !!value?.vin ? value.vin : '');
		raFillingDataForm.setValue('vehicleDetails.kmOnStart', !!value?.kms ? value.kms : '');
		raFillingDataForm.setValue('vehicleDetails.tankLevelOnStart', !!value?.currentTermicTankFilling ? value.currentTermicTankFilling + '/8': '');
		raFillingDataForm.setValue('vehicleDetails.batteryLevelOnStart', !!value?.currentElectricTankFilling ? value.currentElectricTankFilling + '%': '');
		raFillingDataForm.setValue('vehicleDetails.enginePowerGroupCode', !!value?.enginePowerGroupCode ? value.enginePowerGroupCode : '');
		raFillingDataForm.setValue('vehicleDetails.rdfiCard', !!value?.rfidCardNumber ? value.rfidCardNumber : '');
		raFillingDataForm.setValue('vehicleDetails.eToll', !!value?.etollEquipNumber ? value.etollEquipNumber : '');
		raFillingDataForm.setValue('vehicleDetails.chargingCableDomesticType', !!value?.chargingCableDomesticType ? value.chargingCableDomesticType : '');
		raFillingDataForm.setValue('vehicleDetails.chargingCableType2', !!value?.chargingCableType2 ? value.chargingCableType2 : '');
		raFillingDataForm.setValue('vehicleDetails.carClassDescription', !!value?.carClassDescription ? value.carClassDescription : '');
		raFillingDataForm.setValue('vehicleDetails.carSegmentDescription', !!value?.carSegmentDescription ? value.carSegmentDescription : '');
		raFillingDataForm.setValue('vehicleDetails.keyless', !!value?.keyless ? value.keyless : 'false');
	}

	function findObjectByAcrissCode(input: any, arr: any) {
		for (let i = 0; i < arr.length; i++) {
			if (arr[i].acrissCode === input) {
				return {code: arr[i].acrissCode, description: arr[i].acrissLabel};
			}
		}
		return null;
	}

	useEffect(() => {
		// se vehicleDetails è vuoto arrivo su raFilling per la prima volta altrimenti arrivo con raFilling già popolato
		if (_.isEmpty(raFilling.vehicleDetails)) {
			let acrissObj = findObjectByAcrissCode(bookingDataValue.bookingDetail.acrissCode, listVehiclesReady ?? []);
			raFillingDataForm.setValue('vehicleDetails.acriss', acrissObj);
			handleChangeAcriss(null, acrissObj);
		}
		else if (!_.isEmpty(raFilling.vehicleDetails)) {
			// set form values with raFilling values
			raFillingDataForm.setValue('vehicleDetails.plate', raFilling.vehicleDetails);
			handleChangePlate(null, raFilling.vehicleDetails);
		}
	}, [listVehiclesReady])

	return (
		<>
			<Typography variant={"bodyLarge"} >
				{t("raFilling.vehicleDetails.form.title")}
			</Typography>

			<Box sx={{
				border: '1px solid',
				borderColor: theme.palette.neutral.light,
				borderRadius: 2,
				bgcolor: theme.palette.neutral.main,
				px: theme.spacing(1),
				pb: theme.spacing(1)
			}}>

				{/* Vehicle Filters*/}
				<Grid container columnSpacing={2}>
					<Grid item xs={12} sm={6} md={3}>
						<FormAutocomplete<IRaFillingForm>
							name="vehicleDetails.acriss"
							label={t("raFilling.vehicleDetails.form.label.acriss")}
							control={raFillingDataForm.control}
							fullWidth
							//@ts-ignore
							options={selectionCarOptionList.acriss}
							isOptionEqualToValue={(option, value) => option?.code === value?.code}
							getOptionLabel={(opt) =>  opt?.code + ' - ' + opt?.description}
							onChange={handleChangeAcriss || []}
						/>
					</Grid>

					<Grid item xs={12} sm={6} md={3}>
						<FormAutocomplete<IRaFillingForm>
							name="vehicleDetails.sipp"
							label={t("raFilling.vehicleDetails.form.label.sipp")}
							control={raFillingDataForm.control}
							fullWidth
							// @ts-ignore
							options={selectionCarOptionList.sipp}
							isOptionEqualToValue={(option, value) => option?.code === value?.code}
							getOptionLabel={(opt) => !!opt?.description ? opt?.code + ' - ' + opt?.description : "Sipp Less" }
							onChange={handleChangeSipp || []}
						/>
					</Grid>

					<Grid item xs={12} md={6} sx={{px: theme.spacing(0), display: 'flex', alignItems: 'flex-end'}}>
						<FormAutocomplete<IRaFillingForm>
							name="vehicleDetails.plate"
							label={t("raFilling.vehicleDetails.form.label.plateNumber")}
							control={raFillingDataForm.control}
							fullWidth
							// @ts-ignore
							options={selectionCarOptionList.plate}
							isOptionEqualToValue={(option, value) => option?.plate === value?.plate}
							getOptionLabel={(opt) => opt?.fullDescription}
							onChange={handleChangePlate || []}
						/>

						<Button color={"accent"} onClick={handleReset} sx={{mx: theme.spacing(1), mb: theme.spacing(0.5)}}>
							{t('raFilling.vehicleDetails.button.reset')}
						</Button>
					</Grid>
				</Grid>
			</Box>

			<Grid container columnSpacing={2}>

				<Grid container item xs={12} md={6} columnSpacing={2} sx={{mb: 'auto', display: 'flex', alignItems: 'flex-start'}}>
					<Grid item xs={12} sm={6}>
						<FormTextField<IRaFillingForm>
							name="vehicleDetails.vehicleID"
						    label={t("raFilling.vehicleDetails.form.label.vehicleID")}
							control={raFillingDataForm.control}
							fullWidth
							disabled
						/>
					</Grid>
					<Grid item xs={0} sm={6} />

					<Grid item xs={12} sm={6}>
						<FormTextField<IRaFillingForm>
							name="vehicleDetails.kmOnStart"
							label={t("raFilling.vehicleDetails.form.label.kmOnStart")}
							control={raFillingDataForm.control}
							fullWidth
							disabled
						/>
					</Grid>

					<Grid item xs={12} sm={6}>
						<FormTextField<IRaFillingForm>
							name="vehicleDetails.tankLevelOnStart"
							label={t("raFilling.vehicleDetails.form.label.tankLevelOnStart")}
							control={raFillingDataForm.control}
							fullWidth
							disabled
						/>
					</Grid>

					<Grid item xs={12} sm={6}>
						<FormTextField<IRaFillingForm>
							name="vehicleDetails.batteryLevelOnStart"
							label={t("raFilling.vehicleDetails.form.label.batteryOnStart")}
							control={raFillingDataForm.control}
							fullWidth
							disabled
						/>
					</Grid>

					<Grid item xs={12} sm={6}>
						<FormTextField<IRaFillingForm>
							name="vehicleDetails.rdfiCard"
							label={t("raFilling.vehicleDetails.form.label.rdfiCard")}
							control={raFillingDataForm.control}
							fullWidth
							disabled
						/>
					</Grid>

					<Grid item xs={12} sm={6}>
						<FormTextField<IRaFillingForm>
							name="vehicleDetails.eToll"
							label={t("raFilling.vehicleDetails.form.label.eToll")}
							control={raFillingDataForm.control}
							fullWidth
							disabled
						/>
					</Grid>

					<Grid item xs={12} sm={6}>
						<FormRadioGroup<IRaFillingForm>
							name="vehicleDetails.chargingCableType2"
							label={t("raFilling.vehicleDetails.form.label.chargingCableType2")}
						>
							<FormControlLabel
								value="NO"
								label={t("common.button.no")}
								disabled
								control={<Radio/>}
							/>
							<FormControlLabel
								value="YES"
								label={t("common.button.yes")}
								disabled
								control={<Radio/>}
							/>
						</FormRadioGroup>
					</Grid>

					<Grid item xs={12} sm={6}>
						<FormRadioGroup<IRaFillingForm>
							name="vehicleDetails.chargingCableDomesticType"
							label={t("raFilling.vehicleDetails.form.label.chargingCableDomesticType")}
						>
							<FormControlLabel
								value="NO"
								label={t("common.button.no")}
								disabled
								control={<Radio/>}
							/>
							<FormControlLabel
								value="YES"
								label={t("common.button.yes")}
								disabled
								control={<Radio/>}
							/>
						</FormRadioGroup>
					</Grid>

					<Grid item xs={12} sm={6}>
						<FormRadioGroup<IRaFillingForm>
							name="vehicleDetails.specialConditions"
							label={t("raFilling.vehicleDetails.form.label.specialConditions")}
							readOnly
						>
							<FormControlLabel
										value="false"
										label={t("common.button.no")}
										disabled
										control={<Radio />}
								/>
								<FormControlLabel
										value="true"
										label={t("common.button.yes")}
										disabled
										control={<Radio />}
								/>
						</FormRadioGroup>
					</Grid>

					<Grid item xs={12} sm={6}>
						<FormRadioGroup<IRaFillingForm>
							name="vehicleDetails.keyless"
							label={t("raFilling.vehicleDetails.form.label.keyLess")}
							readOnly
						>
							<FormControlLabel
										value="false"
										label={t("common.button.no")}
										disabled
										control={<Radio />}
								/>
								<FormControlLabel
										value="true"
										label={t("common.button.yes")}
										disabled
										control={<Radio />}
								/>
						</FormRadioGroup>
					</Grid>

				</Grid>

				<Grid container item xs={12} md={6} columnSpacing={2}>
					<Grid item xs={12}>
						<img src={"/images/network/Panda.png"} className="img-width-100"/>
					</Grid>
					<Grid item xs={12}>
							<Typography variant={"body"}>
								{brandModelDescr}
							</Typography>
					</Grid>
				</Grid>
			</Grid>
			
		</>
	)
}

export default VehicleDetails;
